import Button from '../Button/Button';
import styles from './LibraryPurchasePrompt.module.scss';
type Props = {
  onCloseButtonClick: () => void;
  heading: string;
  title: string;
};
const LibraryPurchasePrompt = ({ onCloseButtonClick, heading, title }: Props) => {
  return (
    <section>
      {heading && <h2 className={styles['restricted-titel']}> {heading}</h2>}
      <div className={styles['message-container']}>
        {title && <p className={styles['info-text']}>{title}</p>}
        <div className={styles['btn-container']}>
          <Button color="primary" variant="contained" size="large" onClick={onCloseButtonClick} label="OK" className={styles['conform-btn']}></Button>
        </div>
      </div>
    </section>
  );
};

export default LibraryPurchasePrompt;
